<template>
    <div>
        <CRow>
            <CCol>
                <ejs-grid ref='grid' :dataSource='contractTypedata' :allowFiltering='true' :allowPaging='true' :allowResizing='true' :allowReordering='true' :allowSorting='true' :toolbar='toolbar' :editSettings='editSettings' :pageSettings='pageSettings' :filterSettings='filterOptions' :toolbarClick='toolbarClick' :actionComplete='actionComplete' :actionFailure="actionFailure" :allowExcelExport='true' :excelExportComplete='excelExportComplete'>
                    <e-columns>
                        <e-column field='id' headerText='Id' :isPrimaryKey='true' :visible='false'></e-column>
                        <e-column field='name' headerText='Contract Type' :validationRules="nameRules" width=120></e-column>
                        <!--<e-column field='stateId' headerText='Country' :validationRules="requiredRules" width=120 :edit='countryParams' foreignKeyField='stateId' foreignKeyValue='stateName' :dataSource='countries' editType='dropdownedit'></e-column>-->
                    </e-columns>
                </ejs-grid>
            </CCol>
        </CRow>
    </div>
</template>

<script>
    import Vue from "vue";
    import { GridPlugin, Edit, Page, Toolbar, Sort, Filter, Reorder, Resize, ExcelExport, ForeignKey } from "@syncfusion/ej2-vue-grids";
    import { Query } from '@syncfusion/ej2-data';
    import { createElement } from '@syncfusion/ej2-base';
    import { DataManager, WebApiAdaptor, ODataV4Adaptor } from "@syncfusion/ej2-data";
    import { DropDownList, DropDownListPlugin } from "@syncfusion/ej2-dropdowns";
    import { createSpinner, showSpinner, hideSpinner } from '@syncfusion/ej2-popups';
    import { DialogUtility } from '@syncfusion/ej2-popups';
    import gridOptions from '../../common/gridOptions';
    import axios from 'axios';

    import SyncHelper from '../../common/syncfusion'

    Vue.use(DialogUtility);
    Vue.use(GridPlugin);

    let states = SyncHelper.getDataManager('Utils/states');

    let dpState, elState
    export default {
        name: 'contractType',
        data() {
            return {
                contractTypedata: SyncHelper.getDataManager("ContractType"),
                pageSettings: gridOptions.pageSettings,
                editSettings: {
                    showConfirmDialog: true,
                    showDeleteConfirmDialog: true,
                    allowEditing: this.$store.state.permissions["Permissions.ContractTypes.Update"],
                    allowAdding: this.$store.state.permissions["Permissions.ContractTypes.Create"],
                    allowDeleting: this.$store.state.permissions["Permissions.ContractTypes.Delete"],
                    mode: 'Dialog'
                },
                requiredRules: { required: true },
                nameRules: { required: true, maxLength: 512 },
                toolbar: ['Add', 'Edit', 'Delete', 'ExcelExport'],

                countries: states,
                //countryParams: {
                //    create: () => {
                //        elState = document.createElement('input');
                //        return elState;
                //    },
                //    read: () => {
                //        return dpState.value;
                //    },
                //    destroy: () => {
                //        dpState.destroy();
                //    },
                //    write: (args) => {
                //        dpState = new DropDownList({
                //            dataSource: this.countries,
                //            fields: { text: args.column.foreignKeyValue, value: args.column.foreignKeyField },
                //            value: ((args.foreignKeyData && args.foreignKeyData[0]) ? args.foreignKeyData[0][args.column.foreignKeyField] : null),
                //            placeholder: 'Country',
                //            floatLabelType: 'Always'
                //        });
                //        dpState.appendTo(elState);
                       
                //    }
                //},
                filterOptions: gridOptions.filterSettings,
            }
        },

        mounted() {
            createSpinner({
                target: document.getElementById('mainSpinner'),
                width: '50',
                type: 'Material',
                label: 'Loading data...',
                cssClass: 'loadingPoup'
            });
        },
        methods: {
            toolbarClick(args) {
                gridOptions.excelExport(args, "Contract Types.xlsx", this.$refs);
            
            },
            actionBegin(args) {
                gridOptions.actionBegin(args);
                showSpinner(document.getElementById('mainSpinner'));


                if (args.requestType == 'refresh') {
                    hideSpinner(document.getElementById('mainSpinner'));
                }
            },
            excelExportComplete(args) {
                this.$refs.grid.hideSpinner();
            },
            actionComplete(args) {
                gridOptions.actionComplete(args, this.$refs);
                console.log(this.$store.state.permissions);
            },
            actionFailure(args) {
                gridOptions.actionFailure(args);
            }

        },
        provide: {
            grid: [Page, Edit, Toolbar, Sort, Filter, Reorder, Resize, ExcelExport, ForeignKey]
        }
    }
</script>

<style>
</style>